<template>
  <!-- smp: single-month-planning -->
  <base-container class="smp" :fluid="true">
    <h2 class="lvl2-heading smp__capital">
      {{ planning.date.month }}
      <span>{{ planning.date.year }}</span>
    </h2>

    <SingleMonthPlanningTabs @planning-tab-change="handleSupportChange" />
    <div v-if="meta" class="smp__meta">
      <span v-if="meta.msg">{{ meta.msg }}</span>
      <!-- <ToggledCheckbox
        v-if="meta.showCheckbox"
        :checked="isGroupPlanning"
        :disabled="true"
        label="Laisser mon groupement définir mon planning de diffusion"
      /> -->
    </div>
    <base-grid v-if="!isGroupPlanning">
      <template v-if="freeVideos.length">
        <PlannedVideoCard
          v-for="video in freeVideos"
          :key="video.id"
          :video="video"
          :removable="false"
        />
      </template>
      <!-- <SingleMonthPlanningCreditCard :credits="credits" :disabled="true" /> -->
    </base-grid>
  </base-container>
</template>

<script>
import SingleMonthPlanningTabs from "./SingleMonthPlanningTabs"
// import ToggledCheckbox from "@/components/ToggledCheckbox"
import PlannedVideoCard from "./PlannedVideoCard"
import { smpMixin } from "@/mixins"

export default {
  props: ["planning"],
  components: {
    SingleMonthPlanningTabs,
    PlannedVideoCard
    // ToggledCheckbox
  },
  mixins: [smpMixin],
  computed: {
    meta() {
      if (this.isGroupPlanning) {
        return {
          showCheckbox: true,
          msg:
            "Vous aviez laissé votre groupement définir votre liste de diffusion pour ce mois-ci"
        }
      }
      if (!this.hasPlannedVideos) {
        return {
          msg: "Vous n'aviez planifié aucune vidéo dans cette liste ce mois-ci"
        }
      }
      return null
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.smp {
  padding-bottom: 50px;
  &__meta {
    display: inline-flex;
    width: 100%;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin: 0 0 44px;
    & > span {
      max-width: 665px;
      margin-right: 10px;
    }
    & > .checkbox {
      margin-left: auto;
    }
  }
  &__group-planning {
    width: 100%;
    text-align: center;
    button {
      max-width: 475px;
    }
  }
  &__capital {
    text-transform: capitalize;
  }
}
</style>
